import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ElementsModule } from '../../custom-elements/elements.module';
import { BaseModule } from '../base.module';
import { NonSessionComponent } from './component';
import { RoutingModule } from './routing';
import { MatStepperModule } from '@angular/material';
import { AdmissionPageComponent } from './admission-page/admission-page';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';

import { MatFormFieldModule } from '@angular/material/form-field';
import { SiliconAdmissionPageComponent } from './silicon-admission-page/silicon-admission-page';





@NgModule({
  declarations: [
    NonSessionComponent,
    AdmissionPageComponent,
    SiliconAdmissionPageComponent
  ],
  imports: [
    RoutingModule,
    ElementsModule,
    MatMenuModule,
    MatSelectModule,
    MatCardModule,
    MatFormFieldModule,
    MatTabsModule,
    NgbModule.forRoot(),
    BaseModule,
    MatIconModule,
    FlexLayoutModule,
    MatStepperModule,
  ],
  exports: [],
  providers: [],
  bootstrap: [],
  schemas: []
})
export class NonSessionModule {
  constructor() {
  }
}
